export default __webpack_public_path__ + "static/media/live.b333682f.png";